import { OptionDefinition } from "../../Commons/Options/CommandBasedOptionsParser";

export const devModeOption: OptionDefinition<{ developmentMode: boolean }> = {
    name: "development-mode",
    doesNotRequireValue: true,
    defaultValue: { developmentMode: false },
    parse: (x: boolean) => ({ developmentMode: x }),
    description: "Используется только в режиме разработки cli.",
};

export const logVerbosityOption: OptionDefinition<{ logVerbosity: number }> = {
    name: "verbose",
    alias: "v",
    doesNotRequireValue: true,
    defaultValue: { logVerbosity: 0 },
    parse: (x: boolean) => ({ logVerbosity: x ? 1 : 0 }),
    description: "Выводить отладочную информацию на консоль.",
};
